"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardHeader = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CardHeaderMixin = require("../../mixins/components/CardHeaderMixin");
/**
 * @since 4.1.0
 */

var CardHeader = /*#__PURE__*/_styledComponents.default.h5.withConfig({
  displayName: "CardHeader",
  componentId: "c11n-8-107-0__sc-ihwhqj-0"
})(["", ""], _CardHeaderMixin.CardHeaderMixin);
exports.CardHeader = CardHeader;
CardHeader.displayName = 'CardHeader';

/** @component */